import { Drawer, Grid } from 'antd';
import { FiX } from 'react-icons/fi';
import { RightSidebar } from '../right-sidebar';
import { useTranslation } from 'react-i18next';

const { useBreakpoint } = Grid;

const Actions = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const screens = useBreakpoint();
  const { t } = useTranslation();
  return (
    <>
      <Drawer
        title={t('pages.dashboard.my-actions')}
        placement="left"
        closable={false}
        onClose={onClose}
        open={open}
        width={screens.xs ? '100%' : 365}
        extra={
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <FiX fontSize={24} onClick={onClose} />
          </div>
        }
      >
        <div className="layout-right-sidebar-content">
          <RightSidebar />
        </div>
      </Drawer>
    </>
  );
};

export default Actions;